<div class="progress">
    <div role="progressbar" [ngClass]="customNgClass" [ngStyle]="styleClass" [attr.aria-valuenow]='progress' aria-valuemin="0" aria-valuemax="100">{{progress}}%</div>
</div>